const imageUrl = originalUrl =>
  `${originalUrl}&fit=fill&fill=solid&trim-color=FFFFFF&trim=color&trim-tol=8&w=307&h=480&dpr=2`;

const thumbUrl = originalUrl =>
  `${originalUrl}&fit=fill&fill=solid&trim-color=FFFFFF&trim=color&trim-tol=8&w=48&h=60&dpr=3s`;

const zoomUrl = (originalUrl, width, height) =>
  `${originalUrl}&fit=fill&fill=solid&trim-color=FFFFFF&trim=color&trim-tol=8&w=${width}&h=${height}`;

const dtfImageUrl = originalUrl =>
  `${originalUrl}&fit=fill&fill=solid&trim-color=FFFFFF&trim=color&trim-tol=8&w=307&h=307&dpr=2`;

export default {
  imageUrl,
  thumbUrl,
  zoomUrl,
  dtfImageUrl
};
